module.exports = {
    API_URL: 'https://user.mediana.kz/'
}